/**
 * 参考: Wikipedia
 * @see https://ja.wikipedia.org/wiki/%E9%83%B5%E4%BE%BF%E7%95%AA%E5%8F%B7
 */
const zipcodeRegexp = new RegExp(/^\d{3}[-]?\d{4}$/);

const zipcode = (value: string) => {
  if (value === "") {
    return true;
  }

  return zipcodeRegexp.test(value);
};

export default zipcode;
